import { Button, Flex, Form, Input } from '@cowsquare/design';
import gql from 'graphql-tag';
import React, { useCallback } from 'react';
import { withMutation } from 'react-apollo';
import { Field, Form as FinalForm } from 'react-final-form';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { Section } from '../../Section';

const APPLY_MEMBER = gql`
  mutation Apply_Member($input: hkdutest_member_applications_insert_input!) {
    insert_hkdutest_member_applications(objects: [$input]) {
      affected_rows
    }
  }
`;

const Title = styled.h2`
  margin-top: 50px;
`;

const Content = styled(Flex)`
  padding: 20px;
  background-color: #fff;
  margin-bottom: 50px;
  width: 100%;
  box-sizing: border-box;
`;

const FormItem = Form.FormItem;
const required = value => (value ? undefined : 'Required');

const ApplyMember = ({ apply, navigate }) => {
  const onSubmit = useCallback(
    values => {
      apply({ variables: { input: values } }).then(() => {
        navigate('/public/apply/thanks');
      });
    },
    [apply, navigate]
  );

  return (
    <Section>
      <Helmet>
        <title>HKDU Member Application - HKDU Public</title>
      </Helmet>
      <Flex justifyContent="center">
        <Flex flexDirection="column" alignItems="flex-start">
          <Title>HKDU Member Application</Title>
          <Content mt="10px">
            <FinalForm
              onSubmit={onSubmit}
              render={({ handleSubmit, submitting, pristine }) => (
                <Form onSubmit={handleSubmit} layout="vertical" width={[1, '400px']}>
                  <Field name="first_name" validate={required}>
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="First Name" required>
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="last_name" validate={required}>
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Last Name" required>
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="name">
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Chinese Name">
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="hkma_no" validate={required}>
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="HKMA No." required>
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="hkdu_no">
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="HKDU No.">
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="sr_no">
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Specialist Reg No.">
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="email" validate={required}>
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Email Address" required>
                        <Input {...input} type="email" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="phone" validate={required}>
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Mobile Phone" required>
                        <Input {...input} type="text" />
                      </FormItem>
                    )}
                  </Field>
                  <Field name="clinic_phone">
                    {({ input, meta }) => (
                      <FormItem input={input} meta={meta} label="Clinic Phone">
                        <Input {...input} />
                      </FormItem>
                    )}
                  </Field>
                  <FormItem alignItems="flex-end">
                    <Button type="submit" width="100px" variant="primary" disabled={submitting || pristine}>
                      Submit
                    </Button>
                  </FormItem>
                </Form>
              )}
            />
          </Content>
        </Flex>
      </Flex>
    </Section>
  );
};

export default withMutation(APPLY_MEMBER, { name: 'apply' })(ApplyMember);
